/**
 * Created by fers on 21/04/2017.
 */
let lastOrganisationId = null;

export function getLastOrganisationId() {
    return lastOrganisationId;
}

const lastFocusOrgId = 'lastFocusOrg';

export default class LastOrganisationId {
    static exists() {
        return Boolean(lastOrganisationId);
    }

    static get() {
        //eslint-disable-next-line no-undef
        if (global && global.isNode) {
            return '';
        }

        let orgFromUrl = window.location.pathname.match(/\/organisations\/([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})\/.*/);
        let orgIdFromUrl;

        if (orgFromUrl) {
            orgIdFromUrl = orgFromUrl[1];

            if (lastOrganisationId !== orgIdFromUrl) {
                lastOrganisationId = orgIdFromUrl;
            }
        }

        if (!lastOrganisationId) {
            let orgFromUrl = window.location.pathname.match(/\/organisations\/([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})\/.*/);

            if (orgFromUrl) {
                lastOrganisationId = orgFromUrl[1];
            }
        }

        let storedOrgId = window.localStorage.getItem(lastFocusOrgId);
        if (!lastOrganisationId && storedOrgId) {
            lastOrganisationId = storedOrgId;
        }

        return lastOrganisationId;
    }

    static set(organisationId, relay) {
        lastOrganisationId = organisationId;

        if (relay) {
            relay.setVariables({'organisationId': organisationId});
        }

        let orgChangeEvent = new CustomEvent('organisation-change');
        window.dispatchEvent(orgChangeEvent);

        LastOrganisationId.store(organisationId);
    }

    static store(organisationId) {
        window.localStorage.setItem(lastFocusOrgId, organisationId);
    }

    static clear() {
        lastOrganisationId = null;
        if (window && window.localStorage) {
            window.localStorage.removeItem(lastFocusOrgId);
        }
    }
}

//eslint-disable-next-line no-undef
if (!global) {
    window.LastOrganisationId = LastOrganisationId;
}
